var gql = require("@apollo/client").gql;

const EXCLUSIVE_TARIFFS_QUERY_V2_FOR_SEO = gql`
    query TariffsExclusivePageQueryV2ForSeo(
        $region_url: String
        $region_id: Int
        $sort: String
        $actualProviderRating: Boolean
        $fillFieldInfo: Boolean
    ) {
        tariffsExclusivePageV2(
            region_url: $region_url
            region_id: $region_id
            sort: $sort
            actualProviderRating: $actualProviderRating
            fillFieldInfo: $fillFieldInfo
        ) {
            data {
                id
                name
            }
            info {
                providersNameList
                tariffsNameListChannel
                tariffsNameListMobile
                tariffsNameListRouter
                minPrice
                internetSpeedMin
                internetSpeedMax
            }
        }
    }
`;

export default EXCLUSIVE_TARIFFS_QUERY_V2_FOR_SEO;
